import React from "react";

const PremiumCarWash = () => {
  return (
    <div>
      <div>
        <p className="mt-2 mb-2 font-bold">
          {" "}
          Interior & Exterior High Quality foam Wash
        </p>
        <ul className="list-disc text-black-500 ">
          <li>Premium Natural Foam Car Shampoo</li>
          <li>High Pressure Foam Wash</li>
          <li>Interior Cleaning</li>
          <li>High Pressure Vacuum</li>
          <li>
            <b>
              CLEANING INSIDE BONNET IS AT OWNER'S RISK. - NOT RECOMMENDED (RS
              100 EXTRA)
            </b>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PremiumCarWash;
